import type { TDocumentType, TImportantTripDocumentFlags } from 'api/swagger';

export interface IImportantTripDocumentFlagsProps {
  documents: TImportantTripDocumentFlags;
}

export const documentTypeMapping: Record<keyof TImportantTripDocumentFlags, TDocumentType> = {
  withGmr: 'gmr',
  withElo: 'elo',
};
